<template>
	<div class="template choose" v-show="dataVal.IsShow || dataVal.IsShow == null">
		<div class="panel_wrap">
			<label class="panel_title">{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.Property.Require==1" class="require">*</span>
			</label>
			<div class="input_value"  @click='changeVal(dataVal.Property.Title[0].Text)' >
				<!-- v-on:click='changeVal(dataVal.Property.Title[0].Text)' -->
				<!-- <div>{{dataVal.Value}}</div> -->
				<div style="height: 24px;line-height: 24px;">{{dataVal.Value?dataVal.Value:dataVal.Property.Placeholder[0].Text}}</div>
				<i class="icon el-icon-arrow-right"></i>
			</div>
		</div>
	</div>
</template>


<script>
	// import wx from 'weixin-js-sdk'

	export default {
		props: ['dataVal'],
		data() {
			return {

			}
		},
		mounted() {
		},
		methods: {
			changeVal(name) {
				if(this.dataVal.Disable){
					return;
				}
				var that = this;
				that.dataVal.Values = [];
				this.$emit("child-event",this.dataVal,name);
				// window.wx.invoke("selectEnterpriseContact", {
				// 	"fromDepartmentId": -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
				// 	"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
				// 	"type": ["department","user"], // 必填，选择限制类型，指定department、user中的一个或者多个
				// 	"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				// 	"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				// }, function(res) {
				// 	if (res.err_msg == "selectEnterpriseContact:ok") {
				// 		if (typeof res.result == 'string') {
				// 			res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
				// 		}
				// 		var selectedDepartmentList = res.result.departmentList; // 已选的部门列表
						
				// 		for (var i = 0; i < selectedDepartmentList.length; i++) {
				// 			var department = selectedDepartmentList[i];
				// 			that.dataVal.Values.push([department.id,department.name]); // 已选的单个部门ID
				// 			that.dataVal.Value = department.name; // 已选的单个部门名称
				// 		}

				// 	}
				// })
			}
		}

	}
</script>


<style lang="less">
	@import '../assets/css/common.css';

	.choose {
		.input_value {
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			padding-right: 4px;

			.icon {
				position: absolute;
				right: 4px;
				top: 40%;
				font-size: 14px;

			}
		}
	}
</style>
